export enum RouteEnum {
    // landing page
    HOME = '/',
    SHOP = '/',
    LIST = '/list/:listSn',
    SEARCH = '/search',
    PRODUCT = '/product/:productId',
    AGE_GATE = '/age-gate',

    //checkout
    CART = '/cart',
    CHECKOUT = '/checkout',
    PAY = '/pay',
    PURCHASE = '/purchase',

    //account
    LOGIN = '/account/login',
    ACCOUNT = '/account',
    SETTINGS = '/account/settings',
    LOCALE = '/locale',
    PROFILE = '/account/profile',
    ADDRESS_BOOK = '/account/address',
    ORDERS = '/account/orders',
    ORDER = '/account/order/:orderId',
    TRACK = '/account/track/:packageId',
    PACKAGE = '/account/package/:orderId',
    REVIEW = '/review/:orderId',
    REFUND = '/account/refund/:orderItemId',
    REFUND_PROGRESS = '/account/return-progress/:orderItemId',
    COUPONS = '/account/coupons',
    POINTS = '/account/points',
    MESSAGE_CENTER = '/account/message-center',
    MESSAGE_CENTER_TYPE = '/account/message-center/:messageType',
    SECURITY = '/account/security',
    CHANGE_EMAIL_FORM = '/account/change-email-form',
    CHANGE_EMAIL = '/account/change-email',
    REFER_A_FRIEND = '/account/refer-a-friend',
    REFERRAL = '/referral',
    AFFILIATE = '/affiliate',

    //help
    HELP = '/help/:code',
    HELP_CENTER = '/help',
    BLOG = '/growing_guide',
    BLOG_DE = '/vivosun-grow-guide-de',
    HELP_POINTS = '/help/about-points',

    // brand story
    BRAND_STORY = '/brand-story',

    //cache
    CACHE = '/cache-yahaha',

    // diy pools
    DIY_POOLS = '/diy-pool',
    DIY_POOL = '/diy-pool',
    DIY_RECOMMENDED = '/diy-pool/recommended',
    DIY_CUSTOMIZE = '/diy-pool/customize',
    DIY_CART = '/diy-pool/cart',
    DIY_RANKING = '/diy-pool/ranking',

    // activity
    WEEKLY_DEAL = '/weekly-deal',
    POINTS_MALL = '/points-marketplace',
    REDEEM_REWARDS = '/redeem-rewards',

    // 技术指导
    Guides = '/guides',
    // 冬日惊喜
    WinterSurprise = '/winter-surprise',
    // 万圣活动
    TrickOrTreat = '/trick-or-treat',
    // 试用
    TesterClub = '/tester-club',
    TesterClubResults = '/tester-club/:activityId',
    TesterClubReview = '/tester-club/review/:activityId',
    // 众筹
    CrowdFunding = '/crowdfunding',
    CrowdFundingDetail = '/crowdfunding/:code',
    // 冬季种植页
    WINTER_GROW = '/campaign/winter-grow',

    // Community
    Community = '/community',
    CommunityArticle = '/community/article/:articleCode',

    // GiveAway
    VgrowGrowingChallenge = '/vgrow-growing-challenge/:code',

    // 技术指导
    TECHNICAL_GUIDE = '/technical-guide',
    TECHNICAL_GUIDE_ARTICLE = '/technical-guide/:articleGid',

    // 产品说明书
    SUPPORT_GUIDE = '/support/guide/:code',


    //三方
    FACEBOOK_GROUP = 'https://www.facebook.com/groups/1030512458114331',
    Y18_SURVEY = 'https://ydtm8crld30.typeform.com/to/Xf788HdZ',
};